import React, { useState, useEffect } from 'react';
import './Stylesheet.css';
import { ClipLoader } from 'react-spinners';

const CustomLoader = () => {
  const override = {
    display: "block",
    margin: "0 auto",
    marginBottom: '20px',
    marginTop: '20px'
};
  const [currentColorIndex, setCurrentColorIndex] = useState(0);
  const colors = ['#0d6efd', '#02a890', '#9fb9c1', '#27ae60'];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentColorIndex((prevIndex) =>
        prevIndex === colors.length - 1 ? 0 : prevIndex + 1
      );
    }, 400);

    return () => {
      clearInterval(interval);
    };
  }, [colors.length]);
  
  const currentColor = colors[currentColorIndex];

  return(
    <ClipLoader 
    color={currentColor}
      css={override} size={20} />
     )
};
export default CustomLoader;
